import PropTypes from "prop-types";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { useCourseCustomLabels } from "@/react/components/Spaces/CourseSpace/Shared/useCourseCustomLabels";
import { Icon } from "@circle-react/components/shared/Icon";
import { usePunditUserContext } from "@circle-react/contexts";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";

export const LessonButton = ({
  isCompleted,
  isLoading,
  onClick,
  loadingText,
  isFeaturedMediaCompleted,
  shouldEnforceFeaturedMediaCompletion,
  lastAttempt,
  shouldEnforcePassingGrade,
}) => {
  const { lessonLabel, translatedLabels } = useCourseCustomLabels();
  const { isViewOnlyMasquerading } = usePunditUserContext();
  if (isLoading) {
    return (
      <Button disabled className="dark:bg-dark bg-disabled w-44 !px-3">
        {loadingText}
      </Button>
    );
  }

  if (
    (!isFeaturedMediaCompleted && shouldEnforceFeaturedMediaCompletion) ||
    (shouldEnforcePassingGrade &&
      (!lastAttempt || lastAttempt.result !== "passed"))
  ) {
    return (
      <TippyV2
        interactive={false}
        content={
          !isFeaturedMediaCompleted && shouldEnforceFeaturedMediaCompletion
            ? t("courses.view_lesson.featured_media_completion_enforcement", {
                this_lesson: t([
                  "courses.view_lesson",
                  "featured_media_completion_enforcement_variables",
                  "this_lesson",
                  lessonLabel,
                ]),
              })
            : t("courses.view_lesson.passing_grade_enforced")
        }
      >
        <Button
          disabled
          className="dark:bg-dark bg-disabled w-44 !px-3"
          onClick={noop}
        >
          {t("courses.view_lesson.complete", {
            label: translatedLabels.lesson.singular.toLowerCase(),
          })}
          <Icon className="ml-1" type="16-arrow-right" size={16} />
        </Button>
      </TippyV2>
    );
  }
  if (isCompleted) {
    return (
      <TippyV2
        interactive={false}
        content={t("courses.view_lesson.incomplete_lesson")}
      >
        <Button
          variant="secondary"
          onClick={isViewOnlyMasquerading ? noop : onClick}
          className="w-44 !border-gray-300 !px-3"
        >
          <Icon className="mb-0.5 mr-1" type="16-check-circle" size={16} />
          {t("courses.view_lesson.completed_lesson")}
        </Button>
      </TippyV2>
    );
  }

  return (
    <Button
      variant="circle"
      onClick={isViewOnlyMasquerading ? noop : onClick}
      className="w-44 !px-3"
    >
      {t("courses.view_lesson.complete", {
        label: translatedLabels.lesson.singular.toLowerCase(),
      })}
      <Icon className="ml-1" type="16-arrow-right" size={16} />
    </Button>
  );
};

LessonButton.propTypes = {
  isCompleted: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
};
